
    import {Component, Prop, Watch} from 'vue-property-decorator';
    import shrinkableMenu from '@/components/shrinkable-menu/shrinkable-menu.vue';
    import tagsPageOpened from '@/components/tags-page-opened.vue';
    import breadcrumbNav from '@/components/breadcrumb-nav.vue';
    import 'bootstrap/dist/css/bootstrap.min.css';
    import fullScreen from '@/components/fullscreen.vue';
    import lockScreen from '@/components/lockscreen/lockscreen.vue';
    import notice from '@/components/notices/notice.vue';
    import reminder from '@/components/reminder/reminder.vue';
    import util from '@/lib/util';
    import copyfooter from '@/components/Footer.vue'
    import LanguageList from '@/components/language-list.vue'
    import AbpBase from '@/lib/abpbase'
    import ChangePassword from '@/Areas/AppAreaName/Views/admin/profile/change-password.vue'
    import userLinkedModal from '@/Areas/AppAreaName/Views/admin/profile/userLinked/userLinkedModal.vue'
    import {LinkedUserDto} from '@/Areas/AppAreaName/Views/admin/entities/LinkedUserDto'
    import LoginAttempts from '@/Areas/AppAreaName/Views/admin/profile/login-attempts.vue'
    import MySettings from '@/Areas/AppAreaName/Views/admin/profile/my-settings.vue'
    import {SwitchToLinkedAccountInput} from '@/Areas/AppAreaName/Views/admin/entities/SwitchToLinkedAccountInput'
    import config from '@/lib/appconst'
    import Chat from '@/components/chat.vue';
    import chatVideo from '@/components/healthChat/chatVideo.vue';
    import wjdcVue from '@/components/wjdc.vue'
    import Video from '@/components/video.vue';
    import videoModal from '@/components/videoModal.vue';
    import SignalRAspNetCoreHelper from '@/lib/SignalRAspNetCoreHelper';

    class linkedUser implements LinkedUserDto{
        tenantId?: number;
        tenancyName?: string;
        username?: string;
        id?: number;
    }
@Component({
    components: {
        shrinkableMenu,
        tagsPageOpened,
        breadcrumbNav,
        fullScreen,
        lockScreen,
        notice,
        copyfooter,
        LanguageList,
        ChangePassword,
        LoginAttempts,
        MySettings,
        userLinkedModal,
        Chat,
        wjdcVue,
        Video,
        videoModal,
        reminder
    }
})
export default class Main extends AbpBase {
    @Prop({
        type: Boolean,
        default: false
    }) value: boolean;
    shrink: boolean = false;
    showChangePasswordModul: boolean = false;
    showUserLinkedModal:boolean=false;
    showLoginAttemptsModal:boolean=false;
    showMySettingsModal:boolean=false;
    videoModalShow:boolean=false;
    remindershow:boolean=false;
    recentlyLinkedUsers=new Array<linkedUser>();
    // pageTagsList:any;

    get userName() {
        return this.$store.state.session.user ? this.$store.state.session.user.name : ''
    }

    isFullScreen: boolean = false;
    messageCount: string = '0';

    get openedSubmenuArr() {
        return this.$store.state.app.openedSubmenuArr
    }

    get reminderCount() {
      return this.$store.state.app.messageTotal
    }

    get userLinked(){
        return this.$store.state.userlinked.list;
    }

    get menuList() {
        return this.$store.state.app.menuList;
    }

    get pageTagsList() {
        return this.$store.state.app.pageOpenedList as Array < any > ;
    }

    get currentPath() {
        return this.$store.state.app.currentPath;
    }

    get lang() {
        return this.$store.state.app.lang;
    }

    get avatorPath() {
        return localStorage.avatorImgPath;
    }

    get cachePage() {
        return this.$store.state.app.cachePage;
    }

    get menuTheme() {
        return this.$store.state.app.menuTheme;
    }

    get mesCount() {
        return this.$store.state.app.messageCount;
    }
    async init() {
        let data = [
            { genre: 'Sports', sold: 275 },
            { genre: 'Strategy', sold: 115 },
            { genre: 'Action', sold: 120 },
            { genre: 'Shooter', sold: 350 },
            { genre: 'Other', sold: 150 },
        ];
        let pathArr = util.setCurrentPath(this, this.$route.name as string);
        
        let name=this.$store.state.session.user.name;
        this.$store.commit('app/updateMenulist');
        if (pathArr.length >= 2) {
            this.$store.commit('app/addOpenSubmenu', pathArr[1].name);
        }
        let messageCount = 3;
        this.messageCount = messageCount.toString();
        this.checkTag(this.$route.name);
        this.$store.dispatch({
            type:'userlinked/getAll',
            data:null
        }).then((result)=>{
            this.recentlyLinkedUsers=result;
        })

    }

    get userInfo() {
        return this.$store.state.session.user;
    }

    async switchToLinkedUser(linkedUser){
        let input:SwitchToLinkedAccountInput=new class SwitchToLinkedAccountInput{
             targetTenantId?: number;
            targetUserId?: number;
        }
        input.targetTenantId=linkedUser.tenantId;
        input.targetUserId=linkedUser.id;

       let result= await this.$store.dispatch({
            type:'account/switchToLinkedAccount',
            data:input
        })
        //AppAuthService.logout(false);
        let targetUrl =
                  config.appBaseUrl+'/#/'+
                    config.signInAsSomeoneUrlSegment +
                    '?switchAccountToken=' +
                    result.switchAccountToken;
                if (input.targetTenantId) {
                    targetUrl = targetUrl + '&tenantId=' + input.targetTenantId;
                }
                location.href = targetUrl;
    }
    getShownUserName(linkedUser){
        if (!abp.multiTenancy.isEnabled) {
                return linkedUser.username;
            }

            return (
                (linkedUser.tenantId ? linkedUser.tenancyName : '.') +
                '\\' +
                linkedUser.username
            );
    }
    toggleClick() {
        this.shrink = !this.shrink;
    }

    handleClickUserDropdown(name: string) {
        if (name === 'ownSpace') {
            util.openNewPage(this, 'ownspace_index', null, null);
            this.$router.push({
                name: 'ownspace_index'
            });
        } else if (name === 'loginout') {
            this.$store.commit('app/logout', this);
            util.abp.auth.clearToken();
            location.reload();
        } else if (name === 'changePassword') {
            this.showChangePasswordModul = true;
        } else if (name === 'loginAttempts') {
            this.showLoginAttemptsModal = true;
        } else if (name === 'mySettings') {
            this.showMySettingsModal = true;
        }else if (name==='manageAccounts'){
            this.showUserLinkedModal=true;
        }
    }

    checkTag(name ? : string) {
        let openpageHasTag = this.pageTagsList.some((item: any) => {
            if (item.name === name) {
                return true;
            } else {
                return false
            }
        });
        if (!openpageHasTag) {
            util.openNewPage(this, name as string, this.$route.params || {}, this.$route.query || {});
        }
    }

    handleSubmenuChange(val: string) {
        // console.log(val)
    }

    beforePush(name: string) {
        if (name === 'accesstest_index') {
            return false;
        } else {
            return true;
        }
    }

    fullscreenChange(isFullScreen: boolean) {
        // console.log(isFullScreen);
    }

    @Watch('$route')
    routeChange(to: any) {
        this.$store.commit('app/setCurrentPageName', to.name);
        let pathArr = util.setCurrentPath(this, to.name);
        if (pathArr.length > 2) {
            this.$store.commit('app/addOpenSubmenu', pathArr[1].name);
        }
        this.checkTag(to.name);
        localStorage.currentPageName = to.name;
    }

    @Watch('lang')
    langChange() {
        util.setCurrentPath(this, this.$route.name as string);
    }
    async hcmcheck(){
        this.remindershow = false;
        var loginUser = JSON.parse(localStorage.getItem("USEINFO"));
        if(loginUser.roles.indexOf("健管师") != -1 || loginUser.roles.indexOf("医师") != -1 ){
            await this.reminderinit();
        }
        if(loginUser.roles.indexOf("企业管理员") != -1){//企业管理员登录
            await this.getCorporate(loginUser.id);
            this.$router.push({ name: 'corporateUserStatistics' });
        }
        if(loginUser.roles.indexOf("企业负责人") != -1){//企业负责人登录
            await this.getCorporateDepartment(loginUser.id);
            this.$router.push({ name: 'corporateUserStatistics' });
            
        }
        if(loginUser.roles.indexOf("企业部门管理员") != -1){//企业部门管理员登录
            await this.getCorporateDepartment(loginUser.id);
            this.$router.push({ name: 'corporateUserStatistics' });
        }
        if(loginUser.roles.indexOf("企业医师") != -1){//企业医师登录
            await this.getCorporateDoctor(loginUser.id);
            this.$router.push({ name: 'corporateUserStatistics' });
        }
    }
    async getCorporate(userId:any){
        await this.$store.dispatch({
            type:'corporateService/getAll',
            data:{chargeUserIdFilter:userId}
        }).then(re=>{
            if(re.length > 0){
                localStorage.setItem('CorporateId', re[0].xyJ_CorporateInfo.id);
            }
        })
    }
    async getCorporateDepartment(userId:any){
        await this.$store.dispatch('corporatedepartmentService/getAll', {
            data: {chargeUserIdFilter:userId}
        }).then(result=>{
            if(this.$store.state.corporatedepartmentService.list.length > 0){
                var deplist = this.$store.state.corporatedepartmentService.list;
                localStorage.setItem('CorporateId', deplist[0].xyJ_CorporateDepartment.corporateId);
                localStorage.setItem('CorporateDepartmentId', deplist[0].xyJ_CorporateDepartment.id);
            }
        })
    }
    async getCorporateDoctor(userId:any){
        await this.$store.dispatch('corporateuserService/getAllDoctorUser', {
            data: {abpUserId:userId}
        }).then(async result => {
           if(result.items.length>0){
                localStorage.setItem('CorporateId', result.items[0].xyJ_CorporateDoctorUser.corporateId);
           }
        })
    }
    async reminderinit(){
        this.remindershow = true;
        await this.$store.dispatch({
            type: 'reminderInfo/getAllReminderForHealth'
        }).then(result => {
            if(result){
                this.$store.commit('app/setMessageTotal', result);
            }
        })
    }
    async mounted() {
        await this.init();

        // this.$Modal.success({
        //                     title: '参与星医聚客户体验调查',
        //                     content: '<img src="/static/wjdc.jpg">'
        //                 });
        // console.log(JSON.parse(localStorage.getItem('user')));
        // if(this.$store.state.session.user,name=='name'){
        //     this.pageTagsList= [{
        //     meta: { title: '组织机构' },
        //     path: '',
        //     name: 'zzjg'
        // }]
        // }

        this.$store.dispatch({
            type: 'session/init'
        }).then(async result=>{
            localStorage.setItem("USEINFO",JSON.stringify(this.$store.state.session.user));
            if(!!this.$store.state.session.user&&this.$store.state.session.application.features['SignalR']){
                if (this.$store.state.session.application.features['SignalR.AspNetCore']) {
                    SignalRAspNetCoreHelper.initSignalR();
                }
            }
            let name=this.$store.state.session.user.userName;
            this.$store.commit('app/initCachepage');
            this.$store.commit('app/updateMenulist');
            this.$store.commit('app/setOpenedList');
            await this.hcmcheck();
            let dockerInfo={
                user:result,
                socketid:this.$socket.id
            }
            this.$socket.emit('dockerJion',dockerInfo);
        })
        
        
    }
    created() {
        this.$store.commit('app/setOpenedList');
        this.$store.dispatch({
            type: 'session/init',
            data: null
        })
    }
}
